var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgInfo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "info_FILL0_wght300_GRAD-25_opsz20_1_",
    "data-name": "info_FILL0_wght300_GRAD-25_opsz20 (1)",
    d: "M132.083-823.922a.527.527,0,0,0,.381-.159.516.516,0,0,0,.162-.382v-3.983a.518.518,0,0,0-.158-.378.51.51,0,0,0-.374-.159.529.529,0,0,0-.383.159.511.511,0,0,0-.162.378v3.983a.523.523,0,0,0,.158.382A.512.512,0,0,0,132.083-823.922Zm-.012-6.365a.6.6,0,0,0,.432-.168.563.563,0,0,0,.175-.425.6.6,0,0,0-.168-.432.564.564,0,0,0-.425-.175.6.6,0,0,0-.432.168.564.564,0,0,0-.175.425.6.6,0,0,0,.168.432A.564.564,0,0,0,132.071-830.287Zm.015,10.365a7.808,7.808,0,0,1-3.109-.625,8.067,8.067,0,0,1-2.555-1.722,8.079,8.079,0,0,1-1.72-2.552,7.8,7.8,0,0,1-.624-3.11,7.743,7.743,0,0,1,.625-3.1,8.1,8.1,0,0,1,1.722-2.543,8.081,8.081,0,0,1,2.551-1.72,7.8,7.8,0,0,1,3.11-.625,7.742,7.742,0,0,1,3.1.625,8.1,8.1,0,0,1,2.543,1.722,8.094,8.094,0,0,1,1.72,2.546,7.75,7.75,0,0,1,.624,3.1,7.809,7.809,0,0,1-.625,3.109,8.066,8.066,0,0,1-1.722,2.554,8.1,8.1,0,0,1-2.546,1.72A7.75,7.75,0,0,1,132.086-819.922ZM132.078-821a6.673,6.673,0,0,0,4.9-2.024,6.671,6.671,0,0,0,2.024-4.9,6.673,6.673,0,0,0-2.023-4.9,6.671,6.671,0,0,0-4.9-2.024,6.673,6.673,0,0,0-4.9,2.023,6.671,6.671,0,0,0-2.024,4.9,6.673,6.673,0,0,0,2.023,4.9A6.672,6.672,0,0,0,132.078-821ZM132.078-827.922Z",
    transform: "translate(-124.078 835.922)",
    fill: "#f59064"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInfo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/info.a5fa882b.svg";
export { ForwardRef as ReactComponent };